export const throwFormError = (message, responseData = {}) => {
	const err = new Error(message);
	err.response = { data: { general: message, ...responseData } };
	throw err;
};

export const getJSON = (key, fallback = null) => {
	try {
		const raw = localStorage.getItem(key);
		return raw ? JSON.parse(raw) : fallback;
	} catch {
		return fallback;
	}
};

export const setJSON = (key, value) => {
	try {
		localStorage.setItem(key, JSON.stringify(value));
	} catch {}
};


